import type { ReactNode } from 'react';

interface AuthSplitLayoutProps {
  left: ReactNode;
  right: ReactNode;
}

/**
 * Two-column auth page layout.
 */
export function AuthSplitLayout({ left, right }: AuthSplitLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {left}
      {right}
    </div>
  );
}
